import { Countries } from '@constants/enums';
import { FormControl, TextField, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { TAX_VALIDATION } from './constants';
import TaxIdInputStyles from './TaxIdInput.style';
import { TaxIdInputPropsType, TaxIdValidation } from './types';

const TaxIdInput = ({
  title,
  customPlaceholder,
  countryOrigin,
  errors,
  register,
  setValue,
  validationType = TaxIdValidation.GENERIC,
  helperText,
  wrapperClassName,
  textFieldClassName,
  errorClassName,
}: TaxIdInputPropsType) => {
  const { t } = useTranslation();

  const renderErrorMessages = (
    errorType: TaxIdInputPropsType['errors']
  ): string => {
    const { taxId } = errorType;
    const { type } = taxId || {};
    if (type === 'required') {
      return t('defaultError');
    }

    if (type === 'pattern') {
      if (countryOrigin === Countries.COL) {
        return t('onbNitRegexError');
      }
      if (countryOrigin === Countries.MX) {
        return t('onbRfcError');
      }
      return t('onbTaxIdUSAError');
    }

    return '';
  };

  return (
    <FormControl fullWidth className={wrapperClassName}>
      <Typography variant="subtitle2">{t(title)}</Typography>
      <TextField
        autoComplete="off"
        type="text"
        className={clsx(TaxIdInputStyles.inputWrapper, textFieldClassName)}
        size="small"
        placeholder={customPlaceholder ? (t(customPlaceholder) as string) : ''}
        helperText={helperText}
        error={!!errors?.taxId}
        {...register('taxId', {
          required: true,
          pattern: TAX_VALIDATION[validationType],
        })}
        onChange={(e) =>
          setValue('taxId', e.target.value.toUpperCase(), {
            shouldValidate: true,
          })
        }
      />
      {errors?.taxId && (
        <p className={clsx(TaxIdInputStyles.errorWrapper, errorClassName)}>
          {renderErrorMessages(errors)}
        </p>
      )}
    </FormControl>
  );
};

export default TaxIdInput;
